export const APP_USERS_TABLE_HEAD = [
  { id: '1', label: 'Avatar' },
  { id: '2', label: 'Full Name' },
  { id: '3', label: 'Email Address' },
  { id: '4', label: 'Type' },
  { id: '5', label: 'Verified' },
  { id: '6', label: 'Status' },
  { id: '7', label: 'Gender' },
  { id: '8', label: 'Actions' },
];

export const DASHBOARD_USERS_TABLE_HEAD = [
  { id: '1', label: 'Full Name' },
  { id: '2', label: 'Email Address' },
  { id: '3', label: 'Role' },
  { id: '4', label: 'Status' },
  { id: '5', label: 'Actions' },
];

export const CHANNELS_TABLE_HEAD = [
  { id: '1', label: 'Avatar' },
  { id: '2', label: 'English Channel Name' },
  { id: '3', label: 'Arabic Channel Name' },
  { id: '4', label: 'Related Category' },
  { id: '5', label: 'Admin Name' },
  { id: '5', label: 'Created At' },
  { id: '6', label: 'Actions' },
];

export const CHANNEL_VIDEOS_TABLE_HEAD = [
  { id: '1', label: 'Thumbnail' },
  { id: '2', label: 'English Video Title' },
  { id: '3', label: 'Arabic Video Title' },
  { id: '4', label: 'Classification' },
  { id: '5', label: 'Genre' },
  { id: '6', label: 'Admin Name' },
  { id: '7', label: 'Created At' },
  { id: '8', label: 'Status' },
  { id: '9', label: 'Actions' },
];

export const CATEGORIES_TABLE_HEAD = [
  { id: '1', label: 'Avatar' },
  { id: '2', label: 'English Category Name' },
  { id: '3', label: 'Arabic Category Name' },
  { id: '4', label: 'Related Contents' },
  { id: '5', label: 'Actions' },
];

export const SERIES_TABLE_HEAD = [
  { id: '1', label: 'English Series Name' },
  { id: '2', label: 'Arabic Series Name' },
  { id: '3', label: 'Actions' },
];

export const SEASONS_TABLE_HEAD = [
  { id: '1', label: 'English Season Name' },
  { id: '2', label: 'Arabic Season Name' },
  { id: '3', label: 'Series Name' },
  { id: '4', label: 'Actions' },
];

export const EPISODES_TABLE_HEAD = [
  { id: '1', label: 'Thumbnail' },
  { id: '2', label: 'English Title' },
  { id: '3', label: 'Arabic Title' },
  { id: '4', label: 'Episode Number' },
  { id: '5', label: 'Actions' },
];

export const ROLES_TABLE_HEAD = [
  { id: '1', label: 'Role Name' },
  { id: '2', label: 'Users' },
  { id: '3', label: 'Actions' },
];

export const PERMISSIONS_TABLE_HEAD = [
  { id: '1', label: 'System criteria', align: 'left' },
  { id: '2', label: 'View' },
  { id: '3', label: 'Create' },
  { id: '4', label: 'Edit' },
  { id: '5', label: 'Delete' },
];

export const BADGES_TABLE_HEAD = [
  { id: '1', label: 'Badge Icon' },
  { id: '2', label: 'Badge Name' },
  { id: '3', label: 'Badge Type' },
  { id: '4', label: 'Related Category' },
  { id: '5', label: 'Status' },
  { id: '6', label: 'Actions' },
];

export const NOTIFICATIONS_TABLE_HEAD = [
  { id: '1', label: 'Title' },
  { id: '2', label: 'Message' },
  { id: '3', label: 'Privacy' },
  { id: '4', label: 'Channels' },
  // { id: '5', label: 'Status' },
  { id: '6', label: 'Send Date' },
  { id: '7', label: 'Actions' },
];

export const TICKETS_TABLE_HEAD = [
  { id: '1', label: 'Subject' },
  { id: '2', label: 'Message' },
  { id: '3', label: 'Attachment' },
  { id: '4', label: 'Status' },
  { id: '5', label: 'Actions' },
];

export const FAQ_TABLE_HEAD = [
  { id: '1', label: 'Question' },
  { id: '2', label: 'Answer' },
  { id: '3', label: 'Actions' },
];

export const APP_DISCOVERY_TABLE_HEAD = [
  { id: '1', label: 'English Option' },
  { id: '2', label: 'Arabic Option' },
  { id: '3', label: 'Status' },
  { id: '4', label: 'Actions' },
];

export const REPORTED_VIDEOS_TABLE_HEAD = [
  { id: '1', label: 'Video Category' },
  { id: '2', label: 'Reason' },
  { id: '3', label: 'Status' },
  { id: '4', label: 'Actions' },
];

export const CHROME_EXTENSION_TABLE_HEAD = [
  { id: '1', label: 'Full Name' },
  { id: '2', label: 'Suggested Videos' },
  { id: '3', label: 'Status' },
  { id: '4', label: 'Actions' },
];

export const CHROME_EXTENSION_SUGGESTIONS_TABLE_HEAD = [
  { id: '1', label: 'Video Title' },
  { id: '2', label: 'Reviewed By' },
  { id: '3', label: 'Status' },
  { id: '4', label: 'Actions' },
];

export const CHROME_EXTENSION_VOTES_TABLE_HEAD = [
  { id: '1', label: 'Full Name' },
  { id: '2', label: 'Type' },
  { id: '3', label: 'Status' },
];

export const AI_SUGGESTION_KEYWORD_TABLE_HEAD = [
  { id: '1', label: 'English Name' },
  { id: '2', label: 'Arabic Name' },
  { id: '3', label: 'Actions' },
];

export const AI_SUGGESTIONS_TABLE_HEAD = [
  { id: '1', label: 'Title' },
  { id: '2', label: 'Keywords' },
  { id: '3', label: 'Channel Name' },
  { id: '4', label: 'Status' },
  { id: '5', label: 'Actions' },
];

export const PARENT_SUGGESTIONS_TABLE_HEAD = [
  { id: '1', label: 'English Title' },
  { id: '2', label: 'Arabic Title' },
  { id: '2', label: 'Type' },
  { id: '3', label: 'Status' },
  { id: '4', label: 'Actions' },
];

export const ChannelAi_SUGGESTIONS_TABLE_HEAD = [
  // { id: 'checkbox', label: '', align: 'left' },
  { id: '1', label: 'Title' },
  { id: '2', label: 'Type' },
  { id: '3', label: 'Like Count' },
  { id: '4', label: 'View Count' },
  { id: '5', label: 'Video Link' },
  { id: '6', label: 'Status' },
  { id: '7', label: 'Actions' },
];

export const YOUTUBE_VIDEOS_TABLE_HEAD = [
  // { id: 'checkbox', label: '', align: 'left' },
  { id: '1', label: 'Title' },
  { id: '2', label: 'Video Link' },
  { id: '3', label: 'Type' },
  { id: '4', label: 'Is Added' },
];

export const Channel_Youtube_TABLE_HEAD = [
  { id: '1', label: 'Channel Name' },
  { id: '2', label: 'Channel Link' },
  { id: '3', label: 'Video Count' },
  { id: '4', label: 'Added' },
  { id: '5', label: 'Actions' },
];

export const Translated_Channels_TABLE_HEAD = [
  { id: '1', label: 'Month' },
  { id: '2', label: 'Video Count' },
  { id: '3', label: 'Channel Count' },
  { id: '4', label: 'Limit' },
  { id: '5', label: 'Status' },
];

export const CSV_File_Tracker_TABLE_HEAD = [
  { id: '1', label: 'File Name' },
  { id: '2', label: 'Channel Name' },
  { id: '3', label: 'Status' },
  { id: '4', label: 'Progress Percentage' },
];

export const Add_Channel_TABLE_HEAD = [
  // { id: 'checkbox', label: '', align: 'left' },
  { id: '2', label: 'Title' },
  { id: '4', label: 'Video Link' },
  { id: '3', label: 'Type' },
  { id: '4', label: 'Is Added' },
];

export const Add_Publish_Jobs_TABLE_HEAD = [
  { id: '1', label: 'Job ID' },
  { id: '2', label: 'Status' },
  { id: '3', label: 'Type' },
  { id: '4', label: 'Date' },
];

export const Install_Referrer_TABLE_HEAD = [
  { id: '1', label: 'ID' },
  { id: '2', label: 'Source' },
  { id: '3', label: 'Medium' },
  { id: '4', label: 'Campaign' },
  { id: '5', label: 'Install Referrer' },
  { id: '6', label: 'Begin Timestamp' },
  { id: '7', label: 'Click Timestamp' },
];

export const AiSuggestion_Job_Status_TABLE_HEAD = [
  { id: '1', label: 'Job ID' },
  { id: '2', label: 'Status' },
  { id: '3', label: 'Start Date' },
  { id: '4', label: 'End Date' },
];

export const Marketing_TABLE_HEAD = [
  { id: '1', label: 'ID' },
  { id: '2', label: 'Utm Source' },
  { id: '3', label: 'Utm Campaign' },
  { id: '4', label: 'Utm Medium' },
  { id: '5', label: 'Type' },
  { id: '6', label: 'Created Date' },
  { id: '7', label: 'Link' },
];

export const VIDEOS_TABLE_HEAD = [
  { id: '1', label: 'Thumbnail' },
  { id: '2', label: 'English Video Title' },
  { id: '3', label: 'Arabic Video Title' },
  { id: '4', label: 'English Channel Name' },
  { id: '5', label: 'Arabic Channel Name' },
  { id: '6', label: 'Classification' },
  { id: '7', label: 'Genre' },
  { id: '8', label: 'Admin Name' },
  { id: '9', label: 'Created At' },
  { id: '10', label: 'Status' },
  { id: '11', label: 'Actions' },
];

export const CAMPAIGNS_TABLE_HEAD = [
  { id: '1', label: 'Title' },
  { id: '2', label: 'Link' },
  { id: '3', label: 'Type' },
  { id: '4', label: 'Is Published' },
  { id: '5', label: 'Created At' },
  { id: '6', label: 'Actions' },
];
